import { Popconfirm, Tooltip } from "antd";
import { Close, DocsIcon } from "assets/icons";
import React, { ReactNode } from "react";
import { FileModel } from "../UploadFile";
import "./FileLoadedContent.scss";
import Download from "assets/icons/Download";
import ArrowSquareOut from "assets/icons/ArrowSquareOut";

export interface FileLoadedContentProps {
  /**Pass list file loaded */
  file?: FileModel;
  /**Function use to remove file */
  removeFile?: (fileId: string | number) => void;
  /**Option to set component have only view mode */
  isViewMode?: boolean;
  /**Use to custom style the component*/
  className?: string;
  /**Icon */
  icon?: ReactNode;

  onClickFile?: (file: FileModel) => void;

  showIconDowload?: boolean;

  showIconArrowSquareOut?: boolean;

  onClickIcon?: (file: FileModel) => void;

}

export default function FileLoadedContent(props: FileLoadedContentProps) {
  const { file, removeFile, isViewMode, className, icon, onClickFile, onClickIcon, showIconDowload = true, showIconArrowSquareOut = false } = props;

  return (
    <div className={className}>
      <div className="file-loaded-container" key={file?.id}>
        <div className="icon-and-name">
          {icon ? icon : <DocsIcon />}

          {typeof onClickFile === "function" ? (
            <a onClick={() => onClickFile(file)}>
              <Tooltip title={file?.name} placement="topLeft">
                <div className="w-file-name">{file?.name}</div>
              </Tooltip>
            </a>
          ) : (
            <a href={file?.path} download>
              <Tooltip title={file?.name} placement="topLeft">
                <div className="w-file-name">{file?.name}</div>
              </Tooltip>
            </a>
          )}
        </div>

        {!isViewMode ? (
          <div className="remove-file">
            <Popconfirm
              placement="leftTop"
              title={"Bạn có chắc chắn muốn xóa?"}
              onConfirm={() => removeFile(file.id)}
              okText="Xóa"
              cancelText="Hủy"
              okType="danger"
            >
              <div>
                <Close width={16} height={16} />
              </div>
            </Popconfirm>
          </div>
        ) : showIconDowload ? (
          <div style={{ cursor: "pointer" }} onClick={typeof onClickIcon === "function" ? () => onClickIcon(file) : () => onClickFile(file)}>
            <Download />
          </div>
        ) : showIconArrowSquareOut ? (
          <div style={{ cursor: "pointer" }} onClick={typeof onClickIcon === "function" ? () => onClickIcon(file) : () => onClickFile(file)}>
            <ArrowSquareOut />
          </div>
        ) : (<></>)}
      </div>
    </div>
  );
}
